/**
 * Runtime configuration. Values are injected at build time via REACT_APP_* env vars,
 * with sensible defaults for the shared (Cognito reused from health-page) setup.
 *
 * After the backend is deployed, set REACT_APP_API_BASE to the HTTP API invoke URL.
 */

const config = {
  apiBase: process.env.REACT_APP_API_BASE || '',
  cognito: {
    region: process.env.REACT_APP_COGNITO_REGION || 'us-west-2',
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-west-2_hdQ8PQGg6',
    userPoolWebClientId:
      process.env.REACT_APP_COGNITO_CLIENT_ID || '61cb6mn9eulgfmg35c7g6g9u6k'
  },
  // How often (ms) the UI polls a running scenario for status.
  pollIntervalMs: 7000
};

export default config;
